import { FullEngagementFragment } from '@/generated/graphql';

// Title Actions
export const TITLE_CHANGED = 'TITLE_CHANGED';
interface TitleChangedAction {
  type: typeof TITLE_CHANGED;
  payload: {
    title: string;
  };
}
export const titleChanged = (
  payload: TitleChangedAction['payload'],
): TitleChangedAction => ({
  type: TITLE_CHANGED,
  payload,
});

// Description Actions
export const DESCRIPTION_CHANGED = 'DESCRIPTION_CHANGED';
interface DescriptionChangedAction {
  type: typeof DESCRIPTION_CHANGED;
  payload: {
    description: string;
  };
}
export const descriptionChanged = (
  payload: DescriptionChangedAction['payload'],
): DescriptionChangedAction => ({
  type: DESCRIPTION_CHANGED,
  payload,
});

// Config Actions
export const CONFIG_CHANGED = 'CONFIG_CHANGED';
interface ConfigChangedAction {
  type: typeof CONFIG_CHANGED;
  payload: {
    config: Record<string, any>;
  };
}
export const configChanged = (
  payload: ConfigChangedAction['payload'],
): ConfigChangedAction => ({
  type: CONFIG_CHANGED,
  payload,
});

// Data Actions
export const DATA_CHANGED = 'DATA_CHANGED';
interface DataChangedAction {
  type: typeof DATA_CHANGED;
  payload: {
    data: Record<string, any>;
  };
}
export const dataChanged = (
  payload: DataChangedAction['payload'],
): DataChangedAction => ({
  type: DATA_CHANGED,
  payload,
});

// QR Code CTA Actions
export const QR_CODE_CTA_CHANGED = 'QR_CODE_CTA_CHANGED';
interface QrCodeCtaChangedAction {
  type: typeof QR_CODE_CTA_CHANGED;
  payload: {
    qrCodeCta: string;
  };
}
export const qrCodeCtaChanged = (
  payload: QrCodeCtaChangedAction['payload'],
): QrCodeCtaChangedAction => ({
  type: QR_CODE_CTA_CHANGED,
  payload,
});

// Editor Mode Actions
export const EDITOR_MODE_CHANGED = 'EDITOR_MODE_CHANGED';
interface EditorModeChangedAction {
  type: typeof EDITOR_MODE_CHANGED;
  payload: {
    editorMode: 'stage' | 'mobile';
  };
}
export const editorModeChanged = (
  payload: EditorModeChangedAction['payload'],
): EditorModeChangedAction => ({
  type: EDITOR_MODE_CHANGED,
  payload,
});

export type AdminEngagementEditorSnapshot = FullEngagementFragment & {
  editorMode: 'stage' | 'mobile';
};

export const SERVER_ENGAGEMENT_RECEIVED = 'SERVER_ENGAGEMENT_RECEIVED';
interface ServerEngagementReceivedAction {
  type: typeof SERVER_ENGAGEMENT_RECEIVED;
  payload: AdminEngagementEditorSnapshot;
}
export const serverEngagementReceived = (
  payload: ServerEngagementReceivedAction['payload'],
): ServerEngagementReceivedAction => ({
  type: SERVER_ENGAGEMENT_RECEIVED,
  payload,
});

export type ActionType =
  | TitleChangedAction
  | DescriptionChangedAction
  | ConfigChangedAction
  | DataChangedAction
  | QrCodeCtaChangedAction
  | EditorModeChangedAction
  | ServerEngagementReceivedAction;
